<template>
  <div class="rc-l-public rc-l-public--not-found">
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-4 rc-col-text">
            <h1>
              {{ $t(`nav.page_not_found.title`) }}
            </h1>
            <p class="rc-intro--xl">
              {{ $t(`nav.page_not_found.text`) }}
            </p>

            <router-link
              :to="{ name: 'home', params: { locale: $i18n.locale } }"
              class="btn btn-primary btn-xl"
            >
              {{ $t(`nav.page_not_found.cta`) }}
            </router-link>
          </div>
          <div class="col-lg-8">
            <img src="/src/assets/img/illustrations/page_not_found_combined.svg" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style lang="scss" scoped></style>
